<template>
    <div class="land_addon">
        <standart
            title="Акт огляду технічного стану №"
            key="parts_addon"
            :is_active_title="true"
            :is_active_preamblua=false
            :is_active_result=false
            :is_active_problem=false
        ></standart>
        
        <div class="addon_fields_main">
            <div class="auction_land_fields">
                <b-container fluid v-if="draw_addon_fields.length > 0">
                    <div class="main_info">
                        <b-row class="doc_title" :key="field.id" v-for="field in this.draw_addon_fields">
                            <b-col sm="3">
                                <label :for="field.type + field.id">{{field.name}} </label>
                            </b-col>
                            <b-col sm="6">
                                <b-form-input
                                    type="text"
                                    class="fs-xl"
                                    :readonly="check_if_locked(field)"
                                    v-if="field.type == 'input'"
                                    :state="is_valid_field(field)"
                                    v-model="field.insert_val"
                                    :id="field.type + field.id"
                                    size="sm" >
                                </b-form-input>
                                
                                <b-form-radio-group
                                    id="btn-radios-1"
                                    v-if="field.type == 'enum_vid_remont'"
                                    v-model="field.insert_val"
                                    button-variant="outline-primary"
                                    :options="remont_options"
                                    name="radios-btn-default"
                                    buttons
                                ></b-form-radio-group>
                                
                                <date-picker
                                    v-if="field.type == 'date'"
                                    value-type="format"
                                    v-model="field.insert_val"
                                    :lang="d_lang"
                                    :first-day-of-week="1"
                                >
                                </date-picker>
                                
                                <v-select v-model="place_field"
                                          v-if="field.type == 'api_place'"
                                          class="imc_reasons"
                                          label="name"
                                          :options="places"
                                          :filterable="false"
                                >
                                    <template slot="no-options">
                                        Оберіть склад
                                    </template>
                                    <template slot="option" slot-scope="option">
                                        <div class="d-center">
                                            {{ option.name }}
                                            <small >{{option.edrpou}}</small>
                                        </div>
                                    </template>
                                </v-select>
                            </b-col>
                        </b-row>
                        
                        <os_choice :os_field="os_field_in_fields"></os_choice>
                    
                    </div>
                </b-container>
            </div>
            
            <div class="part_items">
                <parts_items  :parts_field="get_filed('parts')"></parts_items>
            </div>
        </div>
    
    </div>
</template>

<script>

import os_choice from "../adv/os_select/os_choice.vue";
import parts_items from "../adv/parts_items.vue";
import standart from "../../standart.vue";

import DatePicker from 'vue2-datepicker'
import vSelect from 'vue-select';
import {createHelpers} from 'vuex-map-fields';

const {mapFields} = createHelpers({
    getterType: 'memorandum_create/getMemCreateField',
    mutationType: 'memorandum_create/updateMemCreateField',
});


export default {
    name: "parts",
    components : {
        os_choice,
        parts_items,
        standart,
        DatePicker,
        vSelect
    },
    data() {
        return {
            places : [],
        }
    },
    created() {
        EventBus.$on("set_memorandum_data", this.remove_dir);
        this.load_places();
    },
    
    
    mounted () {
        setTimeout(() =>  EventBus.$emit('remove_dir'), 1300);
    },
    methods : {
        
        async load_places()
        {
            this.places = [];
            api.get('/parts/places').then(({data}) => {
                if(data.status === 'operation_success') {
                    this.places = data.data;
                }
            }).catch(({response}) => {
                EventBus.$emit('show_toast', {err: response.data.message, type: "danger", title: response.data.status,	position : "b-toaster-top-left"})
            });
        },
        
        remove_dir() {
            EventBus.$emit("remove_dir");
        },
        
        is_valid_field(field) {
            if (field.required === '1') {
                try {
                    if (field.type == 'input') {
                        return field.insert_val.toString().length > 1;
                    }
                } catch (e) {
                
                }
                
                return false;
            }
            return true;
        },
        
        check_if_locked(field)  {
            if(field.insert_type == 'date_current') {
                return true;
            }
            
            return false;
        },
        
        get_filed(type) {
            let filed = null;
            this.addon_fields.map(item => {
                if(item.insert_type === type) {
                    filed = item;
                }
            });
            
            return filed;
        }
        
    },
    
    computed: {
        
        ...mapFields([
            'active_memorandum'
        ]),
        
        
        addon_fields() {
            return this.active_memorandum.addon_data;
        },
        
        current_addon() {
            return 'parts';
        },
        
        
        d_lang() {
            return this.get_datepickLang();
        },
        
        remont_options() {
            let fields_choose = this.remont_field.fields;
            let res = [];
            fields_choose.map(field => {
                let push = {
                    text: field.title,
                    value: field.type
                };
                res.push(push);
            });
            return res;
        },
        
        remont_field() {
            return this.get_filed('enum_vid_remont');
        },
        
        place_field_in_fields()
        {
            return this.get_filed('api_place');
        },
        
        os_field_in_fields()
        {
            return this.get_filed('os_choice');
        },
        
        os_field : {
            get() {
                return this.os_field_in_fields.insert_val;
            },
            set(val) {
                this.os_field_in_fields.insert_val = val;
            }
        },
        
        
        place_field : {
            get() {
                return this.place_field_in_fields.insert_val;
            },
            set(val) {
                this.place_field_in_fields.insert_val = val;
            }
        },
        
        original_field_in_fields()
        {
            return this.get_filed('enum_vid_remont');
        },
        
        
        draw_addon_fields() {
            return this.addon_fields.filter(item => {
                return !(item.insert_type == 'parts' || item.insert_type == 'os_choice');
            });
        },
        
        return_data() {
            return this.addon_fields;
        },
    }
}
</script>

<style scoped>

</style>